(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CurrencyJournalDialogController', CurrencyJournalDialogController);

    CurrencyJournalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CurrencyJournal', 'Currency', 'Country'];

    function CurrencyJournalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CurrencyJournal, Currency, Country) {
        var vm = this;

        vm.currencyJournal = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.currencies = Currency.query();
        vm.countries = Country.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.currencyJournal.id !== null) {
                CurrencyJournal.update(vm.currencyJournal, onSaveSuccess, onSaveError);
            } else {
                CurrencyJournal.save(vm.currencyJournal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:currencyJournalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.activeFrom = false;
        vm.datePickerOpenStatus.activeUntil = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
